import React, { useState } from 'react';

const PRESETS = [0, 5, 10, 15, 20, 25];

export default function DiscountPercentageField({ label, value, onChange }) {
  const [customSelected, setCustomSelected] = useState(false);
  const isCustom = customSelected || !PRESETS.includes(Number(value));

  return (
    <>
      <select
        aria-label={label}
        value={isCustom ? 'custom' : value}
        onChange={e => {
          const custom = e.target.value === 'custom';
          setCustomSelected(custom);
          if (!custom) onChange(Number(e.target.value));
        }}
      >
        {PRESETS.map(percent => (
          <option key={percent} value={percent}>{percent === 0 ? 'No discount' : `${percent}% off`}</option>
        ))}
        <option value="custom">Custom percentage…</option>
      </select>
      {isCustom && (
        <input
          aria-label={`${label} custom percentage`}
          type="number"
          min="0"
          max="100"
          step="0.01"
          required
          value={value}
          onChange={e => {
            setCustomSelected(true);
            onChange(e.target.value);
          }}
          placeholder="Enter percentage"
          style={{ marginTop: 8 }}
        />
      )}
    </>
  );
}
